import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of, withLatestFrom, filter, tap, from, mapTo } from 'rxjs';
import { FittingsService } from '../../services/fittings.service';

// import * as fromStore from '../actions';
import * as fromStore from '..';
import { MonitoringService } from '../../services/monitoring.service';
import { selectActiveSearchResultPartId } from '../fromSearch.barrel';
import { configurationFilterFactory } from '../../models/fitting-query-params.model';

@Injectable()
export class FittingsEffects {
  constructor(
    private actions$: Actions,
    private fittingsService: FittingsService,
    private store: Store<fromStore.State>,
    private monitoringService: MonitoringService
  ) { }

  loadLookups$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.loadFittingLookups),
    switchMap(action => this.fittingsService.getLookups(action.force || false)
      .pipe(map(data => fromStore.actions.FITTINGS.loadFittingLookupsSuccess({ data })),
        catchError(error => of(fromStore.actions.FITTINGS.loadFittingLookupsFailure({ error })))))));

  clearActiveOnSearchResult$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.SEARCH.loadSearchResultsSuccess),
    map(action => fromStore.actions.FITTINGS.clearActiveFitting())
  ));

  // loadLookupsRemoveLoaderIfCached$ = createEffect(() => this.actions$.pipe(
  //   ofType(fromStore.loadFittingLookups),
  //   withLatestFrom(this.store.select(fromStore.selectHasLoadedLookups)),
  //   filter(([action, alreadyLoaded]) => !action.force || !!alreadyLoaded),
  //   map(([action, alreadyLoaded]) => fromStore.removeLoader({ loader: Loaders.loadingLookups }))));

  onPipeSizeChangeRemoveActiveActiveIfundefined$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.changeRegion,
      fromStore.actions.FITTINGS.changePipelineType,
      fromStore.actions.FITTINGS.changeSize,
      fromStore.actions.FITTINGS.changeFittingType,
      fromStore.actions.FITTINGS.changeAnsiClass,
      fromStore.actions.FITTINGS.changeFlangeType,
      fromStore.actions.FITTINGS.changeBranchSize,
      fromStore.actions.FITTINGS.changeDesignCode,
      fromStore.actions.FITTINGS.changeDesignFactor,
      fromStore.actions.FITTINGS.changeMaxDesignPressure,
      fromStore.actions.FITTINGS.changeDesignTempMin,
      fromStore.actions.FITTINGS.changeDesignTempMax,
      fromStore.actions.FITTINGS.changeDesignTempUnit,
      fromStore.actions.FITTINGS.changeMaxCe,
      fromStore.actions.FITTINGS.changeLimit125,
      fromStore.actions.FITTINGS.changeIsBuyAmerica
    ),
    withLatestFrom(this.store.select(fromStore.selectors.FITTINGS.selectQuery)),
    filter(([action, query]) => ((query?.hemisphereId || -1) === -1) || ((query?.pipeSizeId || -1) === -1)),
    map(action => fromStore.actions.FITTINGS.setActiveFitting({ id: null, partNumber: null }))
  ));

  changeFormValue$ = createEffect(() => this.actions$.pipe(
    ofType(
      fromStore.actions.FITTINGS.changeRegion,
      fromStore.actions.FITTINGS.changePipelineType,
      fromStore.actions.FITTINGS.changeSize,
      fromStore.actions.FITTINGS.changeFittingType,
      fromStore.actions.FITTINGS.changeAnsiClass,
      fromStore.actions.FITTINGS.changeFlangeType,
      fromStore.actions.FITTINGS.changeBranchSize,
      fromStore.actions.FITTINGS.changeDesignCode,
      fromStore.actions.FITTINGS.changeDesignFactor,
      fromStore.actions.FITTINGS.changeMaxDesignPressure,
      fromStore.actions.FITTINGS.changeDesignTempMin,
      fromStore.actions.FITTINGS.changeDesignTempMax,
      fromStore.actions.FITTINGS.changeDesignTempUnit,
      fromStore.actions.FITTINGS.changeMaxCe,
      fromStore.actions.FITTINGS.changeLimit125,
      fromStore.actions.FITTINGS.changeIsBuyAmerica
    ),
    withLatestFrom(this.store.select(fromStore.selectors.FITTINGS.selectQuery)),
    filter(([action, query]) => ((query?.hemisphereId || -1) > -1) && ((query?.pipeSizeId || -1) > -1)),
    map(action => fromStore.actions.FITTINGS.loadFittingProducts())
  ))

  loadQueryResult$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.loadFittingProducts),
    withLatestFrom(this.store.select(fromStore.selectors.FITTINGS.selectQuery)),
    switchMap(([action, query]) => this.fittingsService.getQueryResult(query)
      .pipe(map(res => fromStore.actions.FITTINGS.loadFittingProductsSuccess({ res })),
        catchError(error => of(fromStore.actions.FITTINGS.loadFittingProductsFail({ error })))
      ))
  ));

  loadDetail$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.setActiveFitting),
    withLatestFrom(
      this.store.select(fromStore.selectors.FITTINGS.selectActiveFittingId),
      this.store.select(fromStore.selectors.FITTINGS.selectActiveFittingPartNumber)),
    switchMap(([action, id, partNumber]) => this.fittingsService.getDetail(id || -1, partNumber || '')
      .pipe(map(obj => fromStore.actions.FITTINGS.loadActiveFittingDetailsSuccess({ obj })),
        catchError(error => of(fromStore.actions.FITTINGS.loadActiveFittingDetailsFail({ error })))))));


  downloadFittingDrawing$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.loadDrawingFromFlatterFiles),
    // switchMap(action => this.fittingsService.getFittingDrawing(action.id)
    switchMap(action => this.fittingsService.getFlatterFilesDrawingByPartNumber(action.filename)
      .pipe(map(file => {
        window.open(window.URL.createObjectURL(file));
        return fromStore.actions.FITTINGS.loadDrawingFromFlatterFilesSuccess();
      }))),
    catchError(error => of(fromStore.actions.FITTINGS.loadDrawingFromFlatterFilesFail({ error })))
  ));

  loadDwgGraph$ = createEffect(() => this.actions$.pipe(
    ofType(
      fromStore.actions.FITTINGS.setActiveFitting,
      fromStore.actions.FITTINGS.loadActiveFittingDetailsSuccess,
      fromStore.actions.FITTINGS.loadActiveFittingDrawingDictionary
    ),
    withLatestFrom(this.store.select(fromStore.selectors.FITTINGS.selectActiveFittingPartNumber)),
    filter(([action, partNumber]) => !!partNumber),
    switchMap(([action, partNumber]) => this.fittingsService.getFlatterFilesDrawingDictionary(partNumber || 'foo')
      .pipe(map(dictionary => fromStore.actions.FITTINGS.loadActiveFittingDrawingDictionarySuccess({ dictionary })),
        catchError(error => of(fromStore.actions.FITTINGS.loadActiveFittingConfigurationsFail({ error })))))));

  // downloadAssociatedDrawing$ = createEffect(() => this.actions$.pipe(
  //   ofType(fromStore.actions.FITTINGS.loadDrawingFromFlatterFiles),
  //   switchMap(action => this.fittingsService.getFlatterFilesDrawingByPartNumber(action.partNumber)
  //     .pipe(map(file => {
  //       window.open(window.URL.createObjectURL(file));
  //       return fromStore.loadDrawingFromFlatterFilesSuccess();
  //     }))),
  //   catchError(error => of(fromStore.loadDrawingFromFlatterFilesFail({ error })))
  // ));

  // activeSearchItem$ = createEffect(() => this.actions$.pipe(
  //   ofType(fromStore.actions.SEARCH.activateSearchItem),
  //   withLatestFrom(this.store.select(selectActiveSearchResultPartId)),
  //   filter(([action, id]) => action.item.productType === 'Fitting'),
  //   switchMap(([action, id]) => this.fittingsService.getFittingById(id || -1)
  //     .pipe(map(fittingProduct => fromStore.actions.SEARCH.setFittingFilter({ fittingProduct: fittingProduct || {} }))))));

  activeSearchItem$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.SEARCH.activateSearchItem),
    withLatestFrom(this.store.select(selectActiveSearchResultPartId)),
    filter(([action, id]) => action.item.productType === 'Fitting'),
    map(([action, id]) => fromStore.actions.FITTINGS.setActiveFitting({ id: id || -1, partNumber: action.item.partNumber || '' }))
  ));
  // switchMap(([action, id]) => this.fittingsService.getFittingById(id || -1)
  //   .pipe(map(fittingProduct => fromStore.actions.SEARCH.setFittingFilter({ fittingProduct: fittingProduct || {} }))))));

  setActiveItemAfterSearchSelect$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.SEARCH.setFittingFilter),
    filter(action => !!action.fittingProduct),
    map(action => fromStore.actions.FITTINGS.setActiveFitting({ id: action.fittingProduct.id || -1, partNumber: action.fittingProduct.partNumber || ''}))
  ));

  monitorErrors$ = createEffect(() => this.actions$.pipe(
    ofType(
      fromStore.actions.FITTINGS.loadFittingLookupsFailure,
      fromStore.actions.FITTINGS.loadFittingAssociatedDrawingFail,
      fromStore.actions.FITTINGS.loadFittingProductsFail,
      fromStore.actions.FITTINGS.loadFittingDrawingFail,
      fromStore.actions.FITTINGS.loadDrawingFromFlatterFilesFail,
      fromStore.actions.FITTINGS.loadActiveFittingDetailsFail,
      fromStore.actions.FITTINGS.loadActiveFittingConfigurationsFail),
    tap(error => this.monitoringService.logException(error.error)),
    map(error => fromStore.actions.ERRORS.addGlobalError({ error: error.error }))
  ));

  tappedBlindChangeAtTopLevel$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.tappedBlindChangeTopLevel),
    withLatestFrom(this.store.select(fromStore.selectors.FITTINGS.selectTappedHolesFilterSplit)),
    map(([action, holes]) => {
      if (!!action.obj.status) {
        return holes.concat(action.obj.value);
      } else {
        return holes.filter(f => f !== action.obj.value);
      }
    }),
    map(res => fromStore.actions.FITTINGS.changeTopLevelConfigurationFilter({ obj: { tappedBlind: res.filter(f => f.length > 0).join() } }))
  ));

  oringChangeAtTopLevel$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.oringChangeTopLevel),
    withLatestFrom(this.store.select(fromStore.selectors.FITTINGS.selectOringFilterSplit)),
    map(([action, oring]) => {
      if (!!action.obj.status) {
        return oring.concat(action.obj.value);
      } else {
        return oring.filter(f => f !== action.obj.value);
      }
    }),
    map(res => fromStore.actions.FITTINGS.changeTopLevelConfigurationFilter({ obj: { oring: res.filter(f => f.length > 0).join() } }))
  ));

  bevelChangeAtTopLevel$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.bevelChangeTopLevel),
    withLatestFrom(this.store.select(fromStore.selectors.FITTINGS.selectBevelFilterSplit)),
    map(([action, bevel]) => {
      if (!!action.obj.status) {
        return bevel.concat(action.obj.value);
      } else {
        return bevel.filter(f => f !== action.obj.value);
      }
    }),
    map(res => fromStore.actions.FITTINGS.changeTopLevelConfigurationFilter({ obj: { bevel: res.filter(f => f.length > 0).join() } }))
  ));

  tappedBlindChangeAssPartLevel$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.tappedBlindChangeAssPartLevel),
    withLatestFrom(this.store.select(fromStore.selectors.FITTINGS.selectAssPartsTappedHolesFilterSplit)),
    map(([action, holes]) => {
      if (!!action.obj.status) {
        return holes.concat(action.obj.value);
      } else {
        return holes.filter(f => f !== action.obj.value);
      }
    }),
    map(res => fromStore.actions.FITTINGS.changeAssociateProductConfigurationFilter({ obj: { tappedBlind: res.filter(f => f.length > 0).join() } }))
  ));

  oringChangeAssPartLevel$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.oringChangeAssPartLevel),
    withLatestFrom(this.store.select(fromStore.selectors.FITTINGS.selectAssPartsOringFilterSplit)),
    map(([action, orings]) => {
      if (!!action.obj.status) {
        return orings.concat(action.obj.value);
      } else {
        return orings.filter(f => f !== action.obj.value);
      }
    }),
    map(res => fromStore.actions.FITTINGS.changeAssociateProductConfigurationFilter({ obj: { oring: res.filter(f => f.length > 0).join() } }))
  ));

  bevelChangeAssPartLevel$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.bevelChangeAssPartLevel),
    withLatestFrom(this.store.select(fromStore.selectors.FITTINGS.selectAssPartsBevelFilterSplit)),
    map(([action, bevels]) => {
      if (!!action.obj.status) {
        return bevels.concat(action.obj.value);
      } else {
        return bevels.filter(f => f !== action.obj.value);
      }
    }),
    map(res => fromStore.actions.FITTINGS.changeAssociateProductConfigurationFilter({ obj: { bevel: res.filter(f => f.length > 0).join() } }))
  ));

  changeActiveAssociatedPart$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.changeActiveAssociatedPart),
    filter(f => f.partNumber === 'foobar'), // reset the filter if foobar is passed as the partnumber
    map(action => fromStore.actions.FITTINGS.changeAssociateProductConfigurationFilter({
      obj: configurationFilterFactory({
        bevel: '',
        buyAmerica: false,
        liftingLugs: false,
        magInspection: false,
        oring: '',
        tappedBlind: ''
      })
    }))
  ));

  loadOringConfigurationOptions$ = createEffect(() => this.actions$.pipe(
    ofType(fromStore.actions.FITTINGS.loadConfigurationLookupOptions, fromStore.actions.FITTINGS.setActiveFitting),
    withLatestFrom(
      this.store.select(fromStore.selectors.FITTINGS.selectConfigurationFilterLookupsTappedHoles),
      this.store.select(fromStore.selectors.FITTINGS.selectConfigurationFilterLookupsOrings),
      this.store.select(fromStore.selectors.FITTINGS.selectConfigurationFilterLookupsBevels)
    ),
    switchMap(([action, tappedHoles, orings, bevels]) => this.fittingsService.loadConfigurationLookups(tappedHoles, orings, bevels)
      .pipe(map(lookups => fromStore.actions.FITTINGS.loadConfigurationLookupOptionsSuccess({ options: lookups })),
        catchError(error => of(fromStore.actions.FITTINGS.loadConfigurationLookupOptionsFail({ error })))))));
}
